import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import uploadDoc from "../../assets/images/upload-doc.png";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import humburger from "../../assets/images/humburger.png";
import eyeIcon from "../../assets/images/eye-icon.png";
import { createTemplateApi, deleteQuestionnaire, getQuestioner } from "../../actions/riskManagement";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import $ from "jquery";
import './riskmanagementdashboard.css';
import axios from 'axios';

const Questionnaires = () => {
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const id = useSelector((state) => orgId || state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const [isModal, setModal] = useState("");
    const [isModalData, setModalData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(1);
    const [draft, setDraft] = useState();
    const [categoryName, setCategoryName] = useState();
    const [search, setSearch] = useState("");
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const templatesData = useSelector((state) => state?.riskManagement?.response);
    const [showImportModal, setShowImportModal] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [isImporting, setIsImporting] = useState(false);
    const [defaultQuestionnaire, setDefaultQuestionnaire] = useState(null);

    const createTemplateFun = () => {
        createTemplateApi(id)
    }

    const modalClick = (data) => {
        setModalData(data)
        setModal("Form Wizard modal");
    }

    const deleteQuestionnaireButton = (_id) => {
        $.confirm({
            title: "Are you sure?",
            content: "Do you really want to delete this questionnaire?",
            type: "green",
            buttons: {
                ok: {
                    text: "Yes",
                    btnClass: "btn-danger",
                    keys: ["enter"],
                    action: function () {
                        deleteQuestionnaire(id, _id, dispatch)
                    },
                },
                cancel: function () {
                },
            },
        });
    }

    const handleSetDefaultQuestionnaire = (questionerId) => {
        $.confirm({
            title: "Set as Default",
            content: "Do you want to set this questionnaire as default?",
            type: "green",
            buttons: {
                ok: {
                    text: "Yes",
                    btnClass: "btn-success",
                    keys: ["enter"],
                    action: function () {
                        axios.patch(`https://api.brandsek.com/api/tprm/${id}/questioner-forms/${questionerId}/default`)
                            .then(response => {
                                if (response.data && !response.data.error) {
                                    setDefaultQuestionnaire(questionerId);
                                    $.alert({
                                        title: 'Success',
                                        content: 'Questionnaire set as default successfully',
                                        type: 'green'
                                    });
                                    getQuestioner(id, dispatch, draft, search, page, categoryName);
                                } else {
                                    $.alert({
                                        title: 'Error',
                                        content: 'Failed to set questionnaire as default',
                                        type: 'red'
                                    });
                                }
                            })
                            .catch(error => {
                                $.alert({
                                    title: 'Error',
                                    content: 'Failed to set questionnaire as default',
                                    type: 'red'
                                });
                            });
                    },
                },
                cancel: function () {
                },
            },
        });
    }

    const storeSelectedTemplates = (templateId, isChecked) => {
        if (isChecked) {
            setSelectedTemplates([...selectedTemplates, templateId]);
        } else {
            const indexToRemove = selectedTemplates.indexOf(templateId);
            if (indexToRemove !== -1) {
                setSelectedTemplates(selectedTemplates.filter((_, index) => index !== indexToRemove));
            }
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImportFile(file);
            handleImport(file);
        }
    };

    const handleImport = async (file) => {
        if (!file) {
            $.alert({
                title: 'Error',
                content: 'Please select a file to import',
                type: 'red'
            });
            return;
        }

        setIsImporting(true);
        const formData = new FormData();
        formData.append('questionnaire_excel', file);

        try {
            const response = await axios.post(
                `https://api.brandsek.com/api/tprm/${id}/ai-assistant/generate-policy-questionnaire`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data && !response.data.error) {
                const transformedData = transformQuestionnaireData(response.data.data);
                localStorage.setItem('importedQuestionnaire', JSON.stringify(transformedData));
                history.push('/create-questionnaire');
            } else {
                $.alert({
                    title: 'Error',
                    content: 'Failed to import questionnaire. Please try again.',
                    type: 'red'
                });
            }
        } catch (error) {
            $.alert({
                title: 'Error',
                content: 'Failed to import questionnaire. Please try again.',
                type: 'red'
            });
        } finally {
            setIsImporting(false);
            setImportFile(null);
            setShowImportModal(false);
        }
    };

    const transformQuestionnaireData = (apiData) => {
        const categories = Object.entries(apiData).map(([categoryName, questions], index) => ({
            id: index + 1,
            name: categoryName,
            questions: questions.map((question, qIndex) => {
                // Determine the response type
                const responseType = question.questionType === 'boolean' ? 'single_select' :
                    question.questionType === 'singleOption' ? 'single_select' :
                        question.questionType === 'text' ? 'Text' : 'Text';

                // Handle options based on question type
                let options = [];
                if (responseType === 'single_select') {
                    if (question.questionType === 'boolean') {
                        options = ['Yes', 'No'];
                    } else if (question.options && question.options.length > 0) {
                        options = question.options;
                    } else {
                        // For single_select questions without options, add a default option
                        options = ['Option 1'];
                    }
                }

                return {
                    id: qIndex + 1,
                    questionText: question.question,
                    responseType: responseType,
                    options: options,
                    evidence: false,
                    showComment: false,
                    comment: ""
                };
            })
        }));

        return {
            title: "Imported Questionnaire",
            version: "1.0.0",
            categories
        };
    };

    useEffect(() => {
        if (id) {
            getQuestioner(id, dispatch, draft, search, page,categoryName);
        }
    }, [id, draft, search, page,categoryName]);

    useEffect(() => {
        setTotalItems(templatesData?.totalRecords)
        // Find default questionnaire if exists
        if (templatesData?.data) {
            const defaultQ = templatesData.data.find(q => q.isDefaultQuestionnaire);
            if (defaultQ) {
                setDefaultQuestionnaire(defaultQ._id);
            }
        }
    }, [templatesData?.totalRecords, templatesData?.data])

        return (        <div className="container-fluid risk-dashboard">            <div className="block-header">                <div className="row clearfix">                    <div className="col-md-6 col-sm-12">                        <h1 className="welcome-text">Third Party Risk Management</h1>                        <nav aria-label="breadcrumb" className="mt-1">                            <ol className="breadcrumb d-flex align-items-center m-0">                                <li className="breadcrumb-item">                                    <Link to="/vendor" className="text-black">Third Party Risk Management</Link>                                </li>                                <li className="breadcrumb-item active">                                    <Link to="/tprm/questionnaires" className="text-black">Manage Questionnaires</Link>                                </li>                            </ol>                        </nav>                    </div>                    <div className="col-md-6">                            <div className="d-flex justify-content-end align-items-center">                                <button                                    className="btn btn-success btn-sm mx-2"                                    onClick={() => setShowImportModal(true)}                                >                                    <i className="fas fa-file-import mr-2"></i>                                    Import Questionnaire                                </button>                                <Link                                    to="/create-questionnaire"                                    className="btn btn-success btn-sm mx-2"                                    onClick={createTemplateFun}                                >                                    <i className="fas fa-plus mr-2"></i>                                    Create Questionnaire                                </Link>                            </div>                        </div>                </div>            </div>
            <div className="card">
                <div className="body">
                    <div className="row mb-4">
                        <div className="col-sm-3">
                            <div className="searchBoxInput">
                                <div className="input-group">
                                    {/* <div className="input-group-prepend">
                                        <span className="input-group-text bg-white border-right-0">
                                            <i className="fas fa-search text-muted"></i>
                                        </span>
                                    </div> */}
                                    <input
                                        type="text"
                                        placeholder="Search questionnaires..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control border-left-0"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <select
                                className="form-control custom-select"
                                onChange={(e) => setDraft(e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="false">Published</option>
                                <option value="true">Draft</option>
                            </select>
                        </div>
                        <div className="col-sm-3">
                            <select
                                className="form-control custom-select"
                                onChange={(e) => setCategoryName(e.target.value)}
                            >
                                <option value="">All Types</option>
                                <option value="true">General</option>
                                <option value="false">Custom</option>
                            </select>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead className="thead-light">
                                <tr>
                                    <th style={{ width: '25%' }}>Questionnaire Name</th>
                                    <th style={{ width: '15%' }}>Default Status</th>
                                    <th style={{ width: '10%' }}>Type</th>
                                    <th style={{ width: '10%' }}>Version</th>
                                    <th style={{ width: '10%' }}>Status</th>
                                    <th style={{ width: '10%' }}>Date</th>
                                    <th style={{ width: '5%' }}>Preview</th>
                                    <th style={{ width: '10%' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {templatesData?.data?.map((template, index) => (
                                    <tr key={template?._id}>
                                        <td className="align-middle font-weight-medium">{template?.title}</td>
                                        <td className="align-middle">
                                            {template?.isDefaultQuestionare ? (
                                                <span className="badge badge-success px-3 py-2" style={{ 
                                                    fontSize: "12px", 
                                                    fontWeight: "500",
                                                    backgroundColor: "#28a745",
                                                    borderRadius: "4px"
                                                }}>
                                                    <i className="fas fa-check-circle mr-1"></i>
                                                    Default
                                                </span>
                                            ) : (
                                                <button
                                                    className="btn btn-outline-primary btn-sm px-3"
                                                    onClick={() => handleSetDefaultQuestionnaire(template?._id)}
                                                >
                                                    <i className="fas fa-star mr-1"></i>
                                                    Set as Default
                                                </button>
                                            )}
                                        </td>
                                        <td className="align-middle">
                                            <span className={`badge ${template?.isGeneralQuestionnaire ? 'badge-info' : 'badge-secondary'} px-3 py-2`} 
                                                  style={{ fontSize: "12px", fontWeight: "500", borderRadius: "4px" }}>
                                                {template?.isGeneralQuestionnaire ? "General" : "Custom"}
                                            </span>
                                        </td>
                                        <td className="align-middle">{template?.version}</td>
                                        <td className="align-middle">
                                            {template?.isDraft ? (
                                                <span className="badge badge-warning px-3 py-2" style={{ 
                                                    fontSize: "12px", 
                                                    fontWeight: "500",
                                                    backgroundColor: "#ffc107",
                                                    color: "#000",
                                                    borderRadius: "4px"
                                                }}>
                                                    <i className="fas fa-edit mr-1"></i>
                                                    Draft
                                                </span>
                                            ) : (
                                                <span className="badge badge-success px-3 py-2" style={{ 
                                                    fontSize: "12px", 
                                                    fontWeight: "500",
                                                    backgroundColor: "#28a745",
                                                    borderRadius: "4px"
                                                }}>
                                                    <i className="fas fa-check-circle mr-1"></i>
                                                    Published
                                                </span>
                                            )}
                                        </td>
                                        <td className="align-middle">
                                            {moment(template?.createdAt).format("DD MMM YYYY")}
                                        </td>
                                        <td className="align-middle">
                                            <button
                                                className="btn btn-link text-primary p-0"
                                                onClick={() => modalClick(template)}
                                                title="Preview Questionnaire"
                                            >
                                                <i className="fas fa-eye fa-lg"></i>
                                            </button>
                                        </td>
                                        <td className="align-middle">
                                            <div className="btn-group">
                                                {!template?.isDraft && (
                                                    <Link
                                                        to={`/questionnaire/send-questionnaires/${template?._id}`}
                                                        className="btn btn-outline-success btn-sm mr-2"
                                                        title="Send Questionnaire"
                                                    >
                                                        <i className="fas fa-paper-plane mr-1"></i>
                                                        Send
                                                    </Link>
                                                )}
                                                <Link
                                                    to={`/edit-questionnaire/${template?._id}`}
                                                    className="btn btn-outline-primary btn-sm mr-2"
                                                    title="Edit Questionnaire"
                                                >
                                                    <i className="fas fa-edit mr-1"></i>
                                                    Edit
                                                </Link>
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => deleteQuestionnaireButton(template?._id)}
                                                    title="Delete Questionnaire"
                                                >
                                                    <i className="fas fa-trash-alt mr-1"></i>
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="dataTables_paginate">
                        {totalItems > 0 && (
                            <Pagination
                                className="pagination-bar"
                                currentPage={page}
                                totalCount={totalItems}
                                pageSize={10}
                                onPageChange={(page) => {
                                    setPage(page);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-lg" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header border-none pb-0">
                            <div className="boxAVersion d-flex justify-content-between w-100 align-items-center">
                                <h5 className="mb-0 text-white">{isModalData?.title}</h5>
                                <span className="mb-0 px-2 text-white">Version {isModalData?.version}</span>
                            </div>
                            <button
                                type="button"
                                className="close text-white"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal("")}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page overflow-hidden pt-0">
                            <div className="card">
                                <div className="group-box group-box-template p-0 border-none">
                                    <div>
                                        {isModalData?.questions?.map((category, catIndex) => (
                                            <Accordion key={catIndex} defaultExpanded={catIndex === 0}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`panel${catIndex}-content`}
                                                    id={`panel${catIndex}-header`}
                                                >
                                                    {category?.categoryName}
                                                    <span className="boxButton">
                                                        {category?.categoryQuestions?.length}
                                                    </span>
                                                </AccordionSummary>
                                                {category?.categoryQuestions?.map((question, qIndex) => (
                                                    <AccordionDetails key={qIndex}>
                                                        <div className="boxAccordian">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p>
                                                                    {qIndex + 1}. {question?.question_text}
                                                                </p>
                                                                <img src={humburger} className="img-fluid" alt="Menu" />
                                                            </div>
                                                            {question?.evidence == true && (<>
                                                                <span className="uploadDoc">
                                                                    Upload Documents
                                                                    <img src={uploadDoc} className="img-fluid" />
                                                                </span>
                                                            </>)}
                                                            <div className="mb-4">
                                                                {question?.type === "text" ? (
                                                                    <textarea
                                                                        className="form-control form-control-review border-0 inputUpdateLastest"
                                                                        rows="4"
                                                                        placeholder="Response"
                                                                        disabled
                                                                        value={question?.response?.value}
                                                                    ></textarea>
                                                                ) : question?.options?.map((option, optIndex) => (
                                                                    <span
                                                                        key={optIndex}
                                                                        className={`form-control w-50 mt-2 mb-3 border-0 inputUpdateLastest ${question?.response?.value?.includes(option)
                                                                            ? "selectedOption"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        {option}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {question.showComment && (
                                                            <div className="mt-3">
                                                                <textarea
                                                                    className="form-control form-control-review border-0 inputUpdateLastest"
                                                                    placeholder="Comment"
                                                                    disabled
                                                                    value={question.comment || ""}
                                                                    row="4"
                                                                ></textarea>
                                                            </div>
                                                        )}
                                                    </AccordionDetails>
                                                ))}
                                            </Accordion>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Import Questionnaire Modal */}
            <div className={`modal fade ${showImportModal ? 'show d-block' : ''}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title font-weight-bold">Import Questionnaire</h5>
                            <button type="button" className="close" onClick={() => setShowImportModal(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="text-center mb-4">
                                <div className="import-icon-wrapper mb-3">
                                    <i className="fas fa-file-excel fa-3x text-success"></i>
                                </div>
                                <h6 className="font-weight-bold mb-2">Upload Your Questionnaire</h6>
                                <p className="text-muted mb-2">Please ensure your Excel file contains only the questionnaire data.</p>
                                <p className="text-muted small">Supported formats: .xlsx, .xls</p>
                            </div>
                            <div className="text-center">
                                <input
                                    type="file"
                                    id="questionnaire-import"
                                    accept=".xlsx,.xls"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                                <label
                                    htmlFor="questionnaire-import"
                                    className="btn btn-success btn-lg px-4"
                                    style={{ 
                                        cursor: 'pointer',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isImporting ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin mr-2"></i>
                                            Importing...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-upload mr-2"></i>
                                            Choose File
                                        </>
                                    )}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Questionnaires;
